module.exports = __webpack_public_path__ + "img/3_169.6155ef98.png";